import Filter from "./features/Filter";
import List from "./features/List";
import {useEffect, useState} from "react";
import {dashboardSettingListMapInit, dashboardSettingSearchParamInit} from "../detail/state";
import {DashboardSettingSearchParamType} from "../detail/interface";
import {useReadDashboardSetting} from "../detail/hooks/useReadDashboardSetting";
import {useSearchParams} from "react-router-dom";

export const DashboardEdit = () => {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;

    const [searchParam, setSearchParam] = useState<DashboardSettingSearchParamType>(dashboardSettingSearchParamInit)
    const [selectedItem, setSelectedItem] = useState<number[]>([])

    const {data: dashboardSettingApiData} = useReadDashboardSetting({param: searchParam});
    const dashboardSetting = dashboardSettingApiData ?? dashboardSettingListMapInit

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    return (
        <>
            <Filter searchParam={searchParam}
                    setSearchParam={setSearchParam}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}/>

            <List dashboardSetting={dashboardSetting}
                  searchParam={searchParam}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}/>
        </>
    );
}